export default "/yt-reth.5d97e502cfe7a6f7c171a8bd60b0e6a1.svg";